module.exports = __webpack_public_path__ + "img/luce.de26685b.webp";